(function(factory) {
	"use strict";

	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		// CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
})(function(jQuery) {

	function fullScreen(open) {
		if(typeof open == 'undefined') {
			open = !this.fullScreenElement();
		}
		if(open) {
			this.requestFullScreen();
		} else {
			this.cancelFullScreen();
		}
	}

	function isSupported() {
		var element = this[0];
		var requestFullScreen = element.requestFullscreen
				|| element.mozRequestFullScreen
				|| element.webkitRequestFullScreen
				|| element.webkitEnterFullscreen
				|| element.msRequestFullscreen
			;
		return !!requestFullScreen;
	}

	function requestFullScreen() {
		var element = this[0];
		var requestFullScreen = element.requestFullscreen
			|| element.mozRequestFullScreen
			|| element.webkitRequestFullScreen
			|| element.webkitEnterFullscreen
			|| element.msRequestFullscreen
			;
		if(!requestFullScreen) {
			throw new Error('FullScreen method does not exists');
		}
		requestFullScreen.call(element);
	}

	function cancelFullScreen() {
		var cancelFullScreen = document.exitFullscreen
			|| document.mozCancelFullScreen
			|| document.webkitExitFullscreen
			|| document.msExitFullscreen
			;
		if(!cancelFullScreen) {
			throw new Error('FullScreen exit method does not exists');
		}
		cancelFullScreen.call(document);
	}

	function fullScreenElement() {
		return document.fullscreenElement
			|| document.mozFullScreenElement
			|| document.webkitFullscreenElement
			|| document.msFullscreenElement
		;
	}

	function installHandlers() {
		var changeEventName;
		var errorEventName;
		if(document['webkitCancelFullScreen']) {
			changeEventName = 'webkitfullscreenchange';
			errorEventName = 'webkitfullscreenerror';
		} else if(document['mozCancelFullScreen']) {
			changeEventName = 'mozfullscreenchange';
			errorEventName = 'mozfullscreenerror';
		} else if(document['msRequestFullscreen']) {
			changeEventName = 'MSFullscreenChange';
			errorEventName = 'MSFullscreenError';
		}
		if(changeEventName) {
			jQuery(document).bind(changeEventName, function() {
				jQuery(document).trigger(new jQuery.Event("fullscreenchange"));
			});
		}
		if(errorEventName) {
			jQuery(document).bind(errorEventName, function() {
				jQuery(document).trigger(new jQuery.Event("fullscreenerror"));
			});
		}
	}

	jQuery.fn['fullScreen'] = fullScreen;
	jQuery.fn['requestFullScreen'] = requestFullScreen;
	jQuery.fn['cancelFullScreen'] = cancelFullScreen;
	jQuery.fn['fullScreenElement'] = fullScreenElement;
	jQuery.fn['isFullScreenSupported'] = isSupported;
	jQuery(document).ready(function() { installHandlers(); });
});